const EMPTY_LOCALE_EVENT_KEY = 'EMPTY_LOCALE';
class Address {
    constructor(className, methodName, locale) {
        this.className = className;
        this.locale = locale;
        this.methodName = methodName;
    }
}
class SmartMap {
    constructor(type) {
        this.fragments = new Map();
        this.type = type;
    }
    get(key) {
        const map = this.fragments;
        if (!map.has(key)) {
            map.set(key, new this.type());
        }
        return map.get(key);
    }
    remove(key) {
        return this.fragments.delete(key);
    }
}
class ComponentEventMap extends SmartMap {
    constructor() {
        super(Map);
    }
    insert(type, address) {
        const map = this.get(type);
        const key = address.locale ?? EMPTY_LOCALE_EVENT_KEY;
        map?.set(key, address);
    }
    has(type, address) {
        const map = this.get(type);
        const key = address.locale ?? EMPTY_LOCALE_EVENT_KEY;
        return map?.has(key) ?? false;
    }
}
class FragmentEventMap extends SmartMap {
    constructor() {
        super(ComponentEventMap);
    }
}
class ApplicationEventMap extends SmartMap {
    constructor() {
        super(FragmentEventMap);
    }
    getComponent(fragment, component) {
        const item = this.get(fragment);
        return item?.get(component);
    }
}
const EventMapper = new ApplicationEventMap();
export { Address, ApplicationEventMap, ComponentEventMap, EMPTY_LOCALE_EVENT_KEY, EventMapper, FragmentEventMap, SmartMap, };
//# sourceMappingURL=event-mapper.js.map